import './index.scss'
import { useCallback, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import LayoutPartner from '../../components/BasicComponent/LayoutPartner'
import BottomBar from '../../components/BasicComponent/BottomBar'
import BaseTitle from '../../components/BasicComponent/BaseTitle'
import VehicleTypeSelected from '../../components/BasicComponent/VehicleTypeSelected'
import { OPTIONS_VEHICLE_TYPE_INFO_VEHICLE } from '../../constants/vehicle'
import BaseInput from '../../components/BasicComponent/BaseInput'
import BaseButton from '../../components/BasicComponent/BaseButton'
import useLoadHomeCache from '../../hooks/common/useLoadHomeCache'
import useRefreshTrafficFineVehicleListOnRouteEnter from '../../hooks/common/useRefreshTrafficFineVehicleListOnRouteEnter'
import HomeBannerCache from '../../components/BasicComponent/HomeBannerCache'
import CardIconsLinkSupport from '../../components/FeatureComponent/CardIconsLinkSupport'
import VehicleItem from '../../components/BasicComponent/VehicleItem'
import VehicleItemSkeletonList from '../../components/BasicComponent/VehicleItemSkeletonList'
import { useAppUserContext } from '../../context/AppUserContext'
import { useTrafficFineVehicleContext } from '../../context/TrafficFineVehicleContext'
import { sanitizePlateInput, validatePlateNumber } from '../../helper/validatorPlateNumber'
import BasePopup from '../../components/BasicComponent/BasePopup'
import LoadingScreen from '../../components/BasicComponent/LoadingScreen'
import appUserService from '../../services/appUserService'
import { ERROR_CRIMINAL_MESSAGES, HAS_CRIMINAL } from '../../constants/criminal'
import { PATH } from '../../constants/router'
import { VEHICLE_TYPE } from '../../constants/global'
import { LocalStorageManager } from '../../helper/localStorage'
import { useAppParamsContext } from '../../context/AppParamsContext'
import {
  getTrafficFineRegistrationManagementUserKey,
  hasSeenTrafficFineRegistrationManagementFirstTime
} from '../TrafficFineRegistrationManagement/storage'
import { IconArrowDown } from '../../assets/icons'

const LAST_LOOKUP_VEHICLE_TYPE_STORAGE_KEY = 'trafficFineLookupV2VehicleType'
const DEFAULT_VISIBLE_VEHICLE_COUNT = 5

export default function TrafficFineLookupV2() {
  const { isHeaderMiniApp } = useAppParamsContext()
  const { homeBanners, homeCacheLoading } = useLoadHomeCache()
  const { userData } = useAppUserContext()
  const { listVehicleRegisteredPackage, vehicleList, isLoadingVehicleList, getVehicleLists } = useTrafficFineVehicleContext()
  const phoneNumberWithUsernamePrefix = useMemo(() => userData?.phoneNumberWithUsernamePrefix, [userData])
  const [vehicleType, setVehicleType] = useState(() => Number(LocalStorageManager.getItem(LAST_LOOKUP_VEHICLE_TYPE_STORAGE_KEY)) || VEHICLE_TYPE.CAR)
  const [vehicleIdentity, setVehicleIdentity] = useState('')
  const [errorVehicleIdentity, setErrorVehicleIdentity] = useState('')
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [errorSubmit, setErrorSubmit] = useState(null)
  const [isExpandedVehicleList, setIsExpandedVehicleList] = useState(false)
  const history = useHistory()

  const canToggleVehicleList = (vehicleList?.length || 0) > DEFAULT_VISIBLE_VEHICLE_COUNT
  const hiddenVehicleCount = Math.max((vehicleList?.length || 0) - DEFAULT_VISIBLE_VEHICLE_COUNT, 0)
  const visibleVehicleList = useMemo(() => {
    if (!vehicleList) return []
    if (isExpandedVehicleList) return vehicleList
    return vehicleList.slice(0, DEFAULT_VISIBLE_VEHICLE_COUNT)
  }, [vehicleList, isExpandedVehicleList])

  const trafficFineRegistrationManagementUserKey = useMemo(
    () =>
      getTrafficFineRegistrationManagementUserKey({
        phoneNumber: phoneNumberWithUsernamePrefix
      }),
    [phoneNumberWithUsernamePrefix]
  )

  useRefreshTrafficFineVehicleListOnRouteEnter({
    isLoading: isLoadingVehicleList,
    refreshVehicleList: getVehicleLists
  })

  const onSubmit = async (vehicleIdentity, vehicleType, phoneNumber, vehicleListMerged) => {
    if (loadingSubmit) {
      return
    }
    const safeVehicleIdentity = String(vehicleIdentity || '').trim()

    if (!safeVehicleIdentity) {
      setErrorVehicleIdentity('Vui lòng nhập biển số xe!')
      return
    }

    const plateError = validatePlateNumber(safeVehicleIdentity)
    if (plateError) {
      setErrorVehicleIdentity(plateError)
      return
    }

    if (loadingSubmit) {
      return
    }

    const normalizedVehicleType = Number(vehicleType) || VEHICLE_TYPE.CAR
    const payload = {
      licensePlates: safeVehicleIdentity,
      vehicleType: normalizedVehicleType,
      ...(userData?.sdkToken ? {} : { phoneNumber })
    }

    try {
      setLoadingSubmit(true)
      const response = await appUserService.PartnerCustomerCriminalRecordUserCheckViolation(payload)

      if (response.statusCode === 200) {
        const dataRes = response.data
        const criminalRecords = Array.isArray(dataRes?.criminalRecords) ? dataRes.criminalRecords : []

        if (dataRes?.hasCriminal === HAS_CRIMINAL.API_FAIL) {
          setErrorSubmit({
            title: 'Tra cứu không thành công',
            content: 'Đã xảy ra một vài sự cố kỹ thuật, vui lòng thử lại sau ít phút.'
          })
        } else {
          const vehicleActive =
            vehicleListMerged?.find(
              (vehicle) => vehicle.vehicleIdentity === safeVehicleIdentity && Number(vehicle.vehicleType) === normalizedVehicleType
            ) || {}

          if (dataRes?.hasCriminal === HAS_CRIMINAL.YES || dataRes?.hasCriminal === HAS_CRIMINAL.NO) {
            LocalStorageManager.setItem(LAST_LOOKUP_VEHICLE_TYPE_STORAGE_KEY, normalizedVehicleType)
            history.push({
              pathname: PATH.TRAFFIC_FINE_CHECK_RESULT,
              state: {
                vehicleIdentity: safeVehicleIdentity,
                vehicleType: normalizedVehicleType,
                phoneNumber,
                isVehicleWarning: criminalRecords.length > 0 ? 1 : 0,
                checkedAt: new Date().toISOString(),
                criminalCount: criminalRecords.length,
                criminalData: criminalRecords,
                vehicleActivePackage: vehicleActive?.productId && vehicleActive
              }
            })
            void getVehicleLists()
            // try {
            //   const resRecord = await appUserService.getCrimeRecords(
            //     {
            //       filter: {
            //         customerRecordPlatenumber: vehicleIdentity,
            //         vehicleType: normalizedVehicleType
            //       }
            //     },
            //     false
            //   )

            //   if (resRecord?.statusCode === 200 && resRecord?.data?.data?.length > 0) {
            //     LocalStorageManager.setItem(LAST_LOOKUP_VEHICLE_TYPE_STORAGE_KEY, normalizedVehicleType)
            //     history.push({
            //       pathname: PATH.TRAFFIC_FINE_CHECK_RESULT,
            //       state: {
            //         vehicleIdentity,
            //         vehicleType: normalizedVehicleType,
            //         phoneNumber,
            //         isVehicleWarning: 1,
            //         checkedAt: new Date().toISOString(),
            //         criminalCount: resRecord?.data?.data?.length,
            //         criminalData: resRecord?.data?.data || [],
            //         vehicleActivePackage: vehicleActive?.productId && vehicleActive
            //       }
            //     })
            //     void getVehicleLists()
            //   } else {
            //     setErrorSubmit({
            //       title: 'Tra cứu không thành công',
            //       content: 'Đã xảy ra một vài sự cố kỹ thuật, vui lòng thử lại.'
            //     })
            //   }
            // } catch (error) {
            //   setErrorSubmit({
            //     title: 'Tra cứu không thành công',
            //     content: 'Đã xảy ra một vài sự cố kỹ thuật, vui lòng thử lại.'
            //   })
            // }
          // } else {
          //   LocalStorageManager.setItem(LAST_LOOKUP_VEHICLE_TYPE_STORAGE_KEY, normalizedVehicleType)
          //   history.push({
          //     pathname: PATH.TRAFFIC_FINE_CHECK_RESULT,
          //     state: {
          //       vehicleIdentity,
          //       vehicleType: normalizedVehicleType,
          //       phoneNumber,
          //       isVehicleWarning: 0,
          //       checkedAt: new Date().toISOString(),
          //       criminalCount: 0,
          //       criminalData: [],
          //       vehicleActivePackage: vehicleActive?.productId && vehicleActive
          //     }
          //   })
          //   void getVehicleLists()
          }
        }
      } else if (response?.error === 'INVALID_PLATE_NUMBER' || response?.error === 'VEHICLE_TYPE_MISMATCH') {
        setErrorVehicleIdentity('Biển số xe không hợp lệ, vui lòng kiểm tra lại.')
      } else if (ERROR_CRIMINAL_MESSAGES?.[response?.error]) {
        setErrorSubmit(ERROR_CRIMINAL_MESSAGES?.[response?.error])
      } else {
        setErrorSubmit({
          title: 'Tra cứu không thành công',
          content: 'Đã xảy ra một vài sự cố kỹ thuật, vui lòng thử lại.'
        })
      }
    } catch (error) {
      setErrorSubmit({
        title: 'Tra cứu không thành công',
        content: 'Đã xảy ra một vài sự cố kỹ thuật, vui lòng thử lại.'
      })
    } finally {
      setLoadingSubmit(false)
    }
  }

  const isLoadingScreenOpen = loadingSubmit || isLoadingVehicleList
  const shouldShowVehicleListSkeleton = isLoadingVehicleList
  const shouldShowVehicleList = !shouldShowVehicleListSkeleton && vehicleList.length > 0

  const handleOpenTrafficFineRegistrationManagement = useCallback(() => {
    if (isLoadingVehicleList) {
      return
    }

    const navigationState = {
      trafficFineRegistrationVehicle: {
        vehicleIdentity: vehicleIdentity || undefined,
        vehicleType: Number(vehicleType) || undefined
      },
      phoneNumber: phoneNumberWithUsernamePrefix
    }

    // Luôn push RegMgmt vào stack trước.
    history.push({
      pathname: PATH.TRAFFIC_FINE_REGISTRATION_MANAGEMENT,
      state: navigationState
    })

    const hasRegisteredVehicle = listVehicleRegisteredPackage.length > 0
    const hasSeenFirstTime = hasSeenTrafficFineRegistrationManagementFirstTime(trafficFineRegistrationManagementUserKey)

    // Nếu là lần đầu và chưa có xe đăng ký, push tiếp FirstTime.
    // Stack: Lookup → RegMgmt → FirstTime
    // Back từ FirstTime → RegMgmt → Back → Lookup
    if (!hasRegisteredVehicle && !hasSeenFirstTime) {
      history.push({
        pathname: PATH.TRAFFIC_FINE_REGISTRATION_MANAGEMENT_FIRST_TIME,
        state: navigationState
      })
    }
  }, [
    history,
    isLoadingVehicleList,
    listVehicleRegisteredPackage.length,
    phoneNumberWithUsernamePrefix,
    trafficFineRegistrationManagementUserKey,
    vehicleIdentity,
    vehicleType
  ])

  const goToPackageInfo = (vehicle) => {
    history.push({
      pathname: PATH.TRAFFIC_FINE_PACKAGE_INFO,
      state: {
        vehicleIdentity: vehicle?.vehicleIdentity,
        vehicleType: vehicle?.vehicleType,
        vehicleActivePackage: vehicle
      }
    })
  }

  // const scrollToTop = () => {
  //   const scrollElement = document.scrollingElement || document.documentElement || document.body
  //   const startTop = scrollElement?.scrollTop || window.pageYOffset || 0

  //   if (!startTop) {
  //     return
  //   }

  //   const duration = 400
  //   const startTime = performance.now()
  //   const easeOutCubic = (progress) => 1 - (1 - progress) ** 3

  //   const step = (currentTime) => {
  //     const progress = Math.min((currentTime - startTime) / duration, 1)
  //     const nextTop = Math.round(startTop * (1 - easeOutCubic(progress)))

  //     window.scrollTo(0, nextTop)
  //     scrollElement.scrollTop = nextTop
  //     document.documentElement.scrollTop = nextTop
  //     document.body.scrollTop = nextTop

  //     if (progress < 1) {
  //       window.requestAnimationFrame(step)
  //     }
  //   }

  //   window.requestAnimationFrame(step)
  // }

  return (
    <LayoutPartner
        noHeader={!isHeaderMiniApp}
        headerTitle="Tra cứu phạt nguội"
        blendHeaderWithBody
      >
      <div className="TrafficFineLookupV2">
        <div className="TrafficFineLookupV2_infoVehicle">
          <div className="TrafficFineLookupV2_infoVehicle_title">Thông tin biển số xe</div>
          <VehicleTypeSelected
            options={OPTIONS_VEHICLE_TYPE_INFO_VEHICLE}
            value={vehicleType}
            onChange={(nextVehicleType) => setVehicleType(nextVehicleType)}
          />
          <div className="TrafficFineLookupV2_infoVehicle_input">
            <BaseInput
              placeholder="Ví dụ: 29A12345"
              value={vehicleIdentity}
              onChange={(event) => {
                const value = sanitizePlateInput(event.target.value)
                setVehicleIdentity(value)
                setErrorVehicleIdentity('')
              }}
              showClear={Boolean(vehicleIdentity)}
              onClear={() => {
                setVehicleIdentity('')
                setErrorVehicleIdentity('')
              }}
              error={errorVehicleIdentity}
              buttonRight={
               <BaseButton
                  type="right"
                  disabled={!String(vehicleIdentity || '').trim() || loadingSubmit}
                  onClick={() =>
                    onSubmit(
                      vehicleIdentity,
                      vehicleType,
                      phoneNumberWithUsernamePrefix,
                      vehicleList
                    )
                  }
                >
                  Kiểm tra
                </BaseButton>
              }
            />
          </div>
        </div>

        {shouldShowVehicleListSkeleton ? (
          <div className="TrafficFineLookupV2_listVehicle">
            <BaseTitle>Xe của bạn</BaseTitle>
            <VehicleItemSkeletonList itemKeyPrefix="traffic-fine-lookup-vehicle-skeleton" />
          </div>
        ) : null}

        {shouldShowVehicleList && (
          <div className="TrafficFineLookupV2_listVehicle">
            <BaseTitle>Xe của bạn ({vehicleList.length})</BaseTitle>
            {visibleVehicleList.map((vehicle, index) => (
              <VehicleItem
                key={index}
                vehicleIdentity={vehicle?.vehicleIdentity}
                vehicleType={vehicle?.vehicleType}
                isRegisteredPackage={vehicle?.productId}
                notifyEndDateTime={vehicle?.notifyEndDateTime}
                registeredPackageMode={2}
                allowRenew={vehicle?.allowRenew}
                onClick={() => {
                  // setVehicleType(vehicle?.vehicleType)
                  // setVehicleIdentity(vehicle?.vehicleIdentity)
                  // setErrorVehicleIdentity('')
                  // window.requestAnimationFrame(scrollToTop)
                  onSubmit(vehicle?.vehicleIdentity, vehicle?.vehicleType, phoneNumberWithUsernamePrefix, vehicleList)
                }}
                onClickArrowRight={() => {
                  onSubmit(vehicle?.vehicleIdentity, vehicle?.vehicleType, phoneNumberWithUsernamePrefix, vehicleList)
                }}
                onActionClick={() => {
                  if (vehicle?.productId) {
                    goToPackageInfo(vehicle)
                    return
                  }

                  history.push({
                    pathname: PATH.TRAFFIC_FINE_SERVICES,
                    state: {
                      trafficFineRegistrationVehicle: {
                        vehicleIdentity: vehicle?.vehicleIdentity || undefined,
                        vehicleType: Number(vehicle?.vehicleType) || undefined
                      }
                    }
                  })
                }}
              />
            ))}

            {canToggleVehicleList ? (
              <button
                type="button"
                className="TrafficFineLookupV2_toggleBtn"
                onClick={() => setIsExpandedVehicleList((prev) => !prev)}
              >
                <span>{isExpandedVehicleList ? 'Thu gọn' : `Xem thêm${hiddenVehicleCount > 0 ? ` (${hiddenVehicleCount})` : ''}`}</span>
                <span className={`TrafficFineLookupV2_toggleArrow ${isExpandedVehicleList ? 'is-expanded' : ''}`.trim()}>
                  <IconArrowDown />
                </span>
              </button>
            ) : null}
          </div>
        )}

        <BasePopup
          open={!!errorSubmit}
          title={errorSubmit?.title}
          content={errorSubmit?.content}
          onClose={() => {
            setErrorSubmit(null)
          }}
        />
        <LoadingScreen open={isLoadingScreenOpen} />
        <CardIconsLinkSupport />
        <HomeBannerCache promoBanners={homeBanners} loading={homeCacheLoading} />
      </div>
      <BottomBar elementPaddingBottom="LayoutPartner" onRegistrationManagementClick={handleOpenTrafficFineRegistrationManagement} />
    </LayoutPartner>
  )
}
